// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DataInfo-module__ui-DataInfo--P4QQt {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 11px;
  color: #1a1a1a;
}

.DataInfo-module__heading--U2o79 {
  color: #1a1a1a;
  font-size: 1.25rem; /* 20px */
  font-weight: 700;
  line-height: 1.2;
}

.DataInfo-module__ui-DataInfo-Item--cJ3W6 {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin: 0;
}

.DataInfo-module__title--QNBQM {
  margin: 0;
  color: #888;
  font-size: 0.75rem; /* 12px */
  font-weight: 400;
  line-height: 1.5;
  white-space: nowrap;
}

.DataInfo-module__content--tlccz {
  margin: 0;
  color: #333;
  font-size: 0.875rem; /* 14px */
  font-weight: 600;
  line-height: 1.25;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/DataInfo/DataInfo.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB,EAAE,SAAS;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".ui-DataInfo {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 11px;\n  color: #1a1a1a;\n}\n\n.heading {\n  color: #1a1a1a;\n  font-size: 1.25rem; /* 20px */\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.ui-DataInfo-Item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n}\n\n.title {\n  margin: 0;\n  color: #888;\n  font-size: 0.75rem; /* 12px */\n  font-weight: 400;\n  line-height: 1.5;\n  white-space: nowrap;\n}\n\n.content {\n  margin: 0;\n  color: #333;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 600;\n  line-height: 1.25;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-DataInfo": `DataInfo-module__ui-DataInfo--P4QQt`,
	"heading": `DataInfo-module__heading--U2o79`,
	"ui-DataInfo-Item": `DataInfo-module__ui-DataInfo-Item--cJ3W6`,
	"title": `DataInfo-module__title--QNBQM`,
	"content": `DataInfo-module__content--tlccz`
};
export default ___CSS_LOADER_EXPORT___;
